import { useMedia } from 'react-use';

import { tabletAndAbove } from '#src/style/mediaQuery.ts';

export const useIsTabletAndAbove = () => useMedia(tabletAndAbove);
